// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","firmReferenceRow":"_1_7wXSOSpEsyaFLE4Twjz0","firmReferenceColumn":"_2Jw5Ica2ZivKA4v9La_lnN","firmReferenceRelationship":"_3snzzXWoiNBY2hDF87dWLn"};